import React, { useEffect, useState } from "react";
import { DescriptionColorEnum, IDescription } from "@/components/YhBox/Types";
import { Button, message } from "antd";
import { YhBox } from "@/components/YhBox";
import { BillDataTable } from "./DataTable";
import { YhAuth } from "@/components/auth/YhAuth";
import { ResourceAuthEnum } from "@/types/FmsResourceAuthEnum";
import { useBillAdjustAmountLogModel } from "../billAdjustAmountLogModel";
import { PageHeader } from "./PageHeader";
import { labelsType } from "@/views/cash/pay/cashPayModel";
import { orgService } from "@/views/base/org/orgService";
import { beService } from "@/views/base/be/beService";
import { DictCodeEnmu } from "@/types/FmsDictEnums";
import useGlobalModel from "@/model/globalModel";
import { AdjustDrawer } from "./AdjustDrawer";
import useNavModel, { RouterParamType } from "@/model/navModel";

export const BillAdjustAmountLog = () => {
    const {
        setBeDs,
        billSummaryData,
        setOrgDs,
        selectedData,
        setWriteoffDrawerVisible,
        loadData,
        setPayMethodLabels,
        loadCustomer,
        billCustomerExport,
        selectedRowKeys,
        setAdjustDrawerVisible,
        searchParam,
        setSearchParam
    } = useBillAdjustAmountLogModel();
    const { getSelectedDict } = useGlobalModel(() => []);
    const { selectedNavId, replaceNav, getSelectedNavState, findNav } = useNavModel();
    const [detailsInfo] = useState<RouterParamType>(getSelectedNavState() as RouterParamType);



    useEffect(() => {
        let obj: labelsType = {}
        orgService.orgTreeDs({}).then(ds => setOrgDs(ds))
        beService.beDs({}).then(ds => setBeDs(ds))
        getSelectedDict(DictCodeEnmu.SETTLE_TYPE).forEach(item => {
            obj[item.value] = item.label
        })
        setPayMethodLabels(obj);
        loadCustomer()
        if(detailsInfo&&detailsInfo?.id=='待审核'){
            setSearchParam({...searchParam,statusList:1})
            loadData({ pageNum: 1 }, { ...searchParam, statusList:1 }).then()
        }
        else{
        loadData({ pageNum: 1 }).then()
    }
    }, []);

    const desc: IDescription[] = [
        {
            label: "充值总额",
            value: billSummaryData.toFixed(2) ?? '0.00',
            color: DescriptionColorEnum.green
        },
    ]
    const onApproval = () => {
        if (selectedRowKeys && selectedRowKeys.length > 0) {
            if (selectedData?.status === 1) {
                setAdjustDrawerVisible(true);
            } else {
                message.error("该条记录不可审核!");
            }
        } else {
            message.error("请选择待审核记录!");
        }
    }
    const action = (
        <>
            <div>
                <Button
                    className="mr-5"
                    type="link"
                    shape="round"
                    onClick={billCustomerExport}
                >
                    导出
                </Button>
                <YhAuth resCode={ResourceAuthEnum.ACC_C_VW_ADJ_AUDIT}>
                <Button
                    className="mr-5"
                    type="link"
                    shape="round"
                    onClick={onApproval}
                >
                    审核
                </Button>
            </YhAuth>
            </div>

        </>
    );
    return (
        <>
            <PageHeader />
            <YhBox title={"调额记录总览"} descriptions={desc} action={action}>
                <BillDataTable />
            </YhBox>
            <AdjustDrawer/>
        </>
    )
}
